"use strict";
var indexedDbUtils_1 = require('../utils/indexedDbUtils');
var ajaxUtils_1 = require("../utils/ajaxUtils");
var ReadingProgressUtils = (function () {
    function ReadingProgressUtils() {
    }
    ReadingProgressUtils.check = function (userId, workId, chapterId, chapterProgress) {
        var _this = this;
        try {
            indexedDbUtils_1.IndexedDb.db.readingProgress.where({ "userId": userId, "workId": workId }).first()
                .then(function (progress) {
                if (progress && (progress.chapterId != chapterId || progress.chapterProgress - chapterProgress > _this.toleranceValue)) {
                    ajaxUtils_1.AjaxUtils.post("reader/reading-progress-tracking", {
                        workId: workId,
                        chapterId: progress.chapterId,
                        chapterProgress: progress.chapterProgress,
                        workProgress: progress.workProgress,
                        cachedChapterId: chapterId,
                        cachedChapterProgress: chapterProgress
                    });
                }
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    ReadingProgressUtils.updateIfNeeded = function (userId, workId, chapterId, chapterProgress, workProgress, sessionId) {
        try {
            indexedDbUtils_1.IndexedDb.db.readingProgress.where({ "userId": userId, "workId": workId }).first()
                .then(function (progress) {
                if (progress) {
                    if (!(progress.sessionId == sessionId && workProgress < progress.workProgress)) {
                        indexedDbUtils_1.IndexedDb.db.readingProgress.update(progress.id, { chapterId: chapterId, chapterProgress: chapterProgress, workProgress: workProgress });
                    }
                }
                else {
                    indexedDbUtils_1.IndexedDb.db.readingProgress.add({ userId: userId, workId: workId, chapterId: chapterId, chapterProgress: chapterProgress, workProgress: workProgress, sessionId: sessionId });
                }
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    ReadingProgressUtils.toleranceValue = 0.5;
    return ReadingProgressUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ReadingProgressUtils;
//# sourceMappingURL=readingProgressUtils.js.map